import React from 'react';
import { styled } from '@compiled/react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import AsyncIcon from '@atlassian/jira-common-components-async-icon/src/view.tsx';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { CreateWorkVideoEducationModalTriggerButton } from '@atlassian/jira-issue-create-commons/src/ui/create-work-video-education-modal-trigger-button/index.tsx';
import {
	MiniHeader as MinimizableModalHeader,
	ModalTitle,
} from '@atlassian/jira-minimizable-modal/src/ui/modal-container/modal-header/index.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

import { expVal } from '@atlassian/jira-feature-experiments';
import type { MiniHeaderProps } from './types.tsx';

const renderIcon = (iconUrl: string) => {
	if (isVisualRefreshEnabled()) {
		return (
			<Box
				testId="issue-create.common.ui.minimizable-modal-mini-header.icon-container"
				xcss={containerStylesWithVR}
			>
				<AsyncIcon width={16} url={iconUrl} />
			</Box>
		);
	}

	return (
		<IconContainer data-testid="issue-create.common.ui.minimizable-modal-mini-header.icon-container">
			<AsyncIcon width={16} url={iconUrl} />
		</IconContainer>
	);
};

export const MiniHeader = ({
	title,
	iconUrl,
	isItalic,
	showHeaderIcon,
	dismissModalEntryPointWrapper,
}: MiniHeaderProps) => (
	<MinimizableModalHeader dismissModalEntryPointWrapper={dismissModalEntryPointWrapper}>
		{showHeaderIcon && iconUrl && renderIcon(iconUrl)}

		<MinimizableModalTitle
			/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
			testId="minimizable-modal.ui.modal-container-mini-header.mini-header"
			// @ts-expect-error - TS2322 - Type '{ children: string; "data-testid": string; isItalic: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<WithOptionalTheme<{ children?: ReactNode; }, any>, any>, any, any>> & Readonly<...>'.
			isItalic={isItalic}
		>
			{expVal('jira_in_product_video_pilot_v1', 'isEnabled', false) ? (
				<Flex alignItems="center" gap="space.050">
					<Flex>{title}</Flex>
					<CreateWorkVideoEducationModalTriggerButton />
				</Flex>
			) : (
				title
			)}
		</MinimizableModalTitle>
	</MinimizableModalHeader>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MinimizableModalTitle = styled(ModalTitle)({
	display: '-webkit-box',
	color: token('color.text'),
	font: token('font.heading.small'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `0 ${gridSize}px`,
	WebkitLineClamp: 2,
	WebkitBoxOrient: 'vertical',
	whiteSpace: 'normal',
	textOverflow: 'normal',
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.div({
	width: '16px',
	height: '16px',
	marginRight: token('space.100'),
});

const containerStylesWithVR = xcss({
	width: token('space.300'),
	height: token('space.300'),
	marginRight: 'space.050',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
